export const APP_CONSTANTS = {
  HEADER_POST_CSRF_TOKEN: 'Post-Csrf-Token',
  ACTIF_SELLER: 'actifSeller',
  HEADER_AUTHORIZATION_BEARER: 'Authorization',
  MISSING_JWT: '"no jwt"'
}
